
import { ToolLinkType } from "src/components/helpers/tool-links-renderer-util/tool-links-renderer-util.type"
import { afnToolLinksTemplates , generateToolLinks } from "src/pages/visibility-page/components/afn/afn.config"
import { mfnToolLinksTemplates } from "src/pages/visibility-page/components/mfn/mfn.config"
import { preSlamToolLinksTemplates } from "src/pages/visibility-page/components/preslam/preslam.config"

export const toolLinksTemplates: Record<string, ToolLinkType> = generateToolLinks({
	...afnToolLinksTemplates,
	...mfnToolLinksTemplates,
	...preSlamToolLinksTemplates
});

export const realmToRegionMap: Record<string, string> = {
	'na': 'iad',
	'eu': 'dub',
	'cn': 'pek',
	'fe': 'pdx'
}

export const realmToFulfillmentMap: Record<string,string> = {
	'na': 'NAFulfillment',
	'eu': 'EUFulfillment',
	'cn': 'CNFulfillment',
	'fe': 'FEFulfillment',
}

/**
 * List of tool link keys that should display a "NEW" icon beside the link label.
 * Add a tool link key here when a new tool is integrated and you want to highlight it to users.
 * Remove the key once the tool is no longer considered new.
 * Example: To mark a tool called 'my-tool' as new, add 'my-tool' to this array.
 */
export const newBadge: string[] = ['txray'];

export const isNewBadge = (toolName: string): boolean =>
	newBadge.indexOf(toolName) !== -1;
